import { CbhFeatureFlag, useCbhFlag } from "@src/appV2/FeatureFlags";

export function useShiftInviteFrictionConfiguration() {
  const config = useCbhFlag(CbhFeatureFlag.SHIFT_INVITE_FRICTION_CONFIG, {
    defaultValue: {
      enabled: false,
    },
  });

  return config;
}
